import { ChangeEvent, MouseEvent } from 'react';
import { observable, action, runInAction } from 'mobx';
import { isEmpty, trim } from 'lodash';
import CryptoJS from 'crypto-js';
// @ts-ignore
import bytes from 'utf8-bytes';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

import Service from '@service/login';

const moForget = observable({
  phone: '', // 手机号码
  captcha: '', // 验证码
  password: '', // 新密码
  checkPwd: '', // 确认密码
  phoneEmpty: false,
  captchaEmpty: false,
  passwordEmpty: false,
  checkPwdEmpty: false,
  qrText: '获取验证码',
  qrClass: '',
  phoneErrorText: '手机号码不能为空',
  checkPwdErrorText: '确认密码不能为空',
});

const reset = action(() => {
  moForget.phone = '';
  moForget.password = '';
  moForget.captcha = '';
  moForget.checkPwd = '';
  moForget.phoneEmpty = false;
  moForget.captchaEmpty = false;
  moForget.passwordEmpty = false;
  moForget.checkPwdEmpty = false;
});

// 输入手机号码
const changePhone = action((ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
  // console.log('手机号码 -- ', ev.target.value);
  if (ev.target.value.length > 11) return;
  moForget.phoneEmpty = false;
  moForget.phone = ev.target.value;
});

// 输入验证码
const changeCaptcha = action((ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
  // console.log('验证码 -- ', ev.target.value);
  if (ev.target.value.length > 4) return;
  moForget.captchaEmpty = false;
  moForget.captcha = ev.target.value;
});

// 输入新密码
const changePassword = action((ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
  // console.log('新密码 -- ', ev.target.value);
  moForget.passwordEmpty = false;
  moForget.password = ev.target.value;
});

// 输入确认密码
const changeCheckPwd = action((ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
  // console.log('确认密码 -- ', ev.target.value);
  moForget.checkPwdEmpty = false;
  moForget.checkPwd = ev.target.value;
});

// 倒计时
const countDown = action(async (num: number) => {
  let newNumber: number = num;
  runInAction(() => {
    moForget.qrText = newNumber.toString();
    moForget.qrClass = 'disable-text60';

    const timer = setInterval(() => {
      newNumber -= 1;
      runInAction(() => {
        moForget.qrText = newNumber.toString();
        if (newNumber <= 0) {
          clearInterval(timer);
          moForget.qrClass = '';
          moForget.qrText = '获取验证码';
        }
      });
    }, 1000);
  });
});

// 获取验证码
const getCaptcha = action(async (ev: MouseEvent) => {
  ev.stopPropagation();
  if (!trim(moForget.phone)) {
    moForget.phoneErrorText = '手机号码不能为空';
    moForget.phoneEmpty = true;
    return;
  }
  if (trim(moForget.phone).length !== 11) {
    moForget.phoneErrorText = '请输入有效的手机号码';
    moForget.phoneEmpty = true;
    return;
  }
  if (moForget.qrText !== '获取验证码') return;
  const params = { account: moForget.phone };
  const res: any = await Service.resetCaptcha(params);
  if (isEmpty(res)) return;
  if (res.code === 0 && res.result?.is_send) {
    toast.success('验证码发送成功', {
      theme: 'dark',
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
      draggable: false,
      pauseOnFocusLoss: false,
    });
    countDown(60);
  } else {
    toast.error(res.msg, {
      theme: 'dark',
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
      draggable: false,
      pauseOnFocusLoss: false,
    });
  }
});

// 修改密码
const toModify = action(async (callback: () => any) => {
  const { phone, password, captcha } = moForget;

  // ------ 密码加密 ------
  let plaintext = password;
  const length = (16 - bytes(plaintext).length % 16) % 16;
  for (let i = 0; i < length; i += 1) plaintext += ' ';
  const pwdString = CryptoJS.enc.Utf8.parse(plaintext);
  const newPwd = CryptoJS.AES.encrypt(pwdString, CryptoJS.enc.Utf8.parse('/H0w<c|:dYV(.q)b'), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.ZeroPadding,
    iv: CryptoJS.enc.Utf8.parse('/H0w<c|:dYV(.q)b'),
  }).toString();
  // const params = { user, password: newPwd, from };
  // console.log('new password -- ', newPwd);
  // ------ 密码加密 ------

  const params = {
    captcha,
    account: phone,
    password: newPwd,
  };
  const res: any = await Service.resetPassword(params);
  if (res.code === 0) {
    toast.success('密码修改成功', {
      theme: 'dark',
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000,
      draggable: false,
      pauseOnFocusLoss: false,
      onClose: callback(),
    });

    localStorage.setItem('account', phone);
    localStorage.setItem('phone', phone);
    localStorage.setItem('password', password);
  } else {
    toast.error(res.msg, {
      theme: 'dark',
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000,
      draggable: false,
      pauseOnFocusLoss: false,
    });
  }
});

// 修改密码
const modifyPassword = action((callback: () => any) => {
  if (!trim(moForget.phone)) {
    moForget.phoneErrorText = '手机号码不能为空';
    moForget.phoneEmpty = true;
    return;
  }
  if (trim(moForget.phone).length !== 11) {
    moForget.phoneErrorText = '请输入有效的手机号码';
    moForget.phoneEmpty = true;
    return;
  }
  if (!trim(moForget.captcha)) {
    moForget.captchaEmpty = true;
    return;
  }
  if (!trim(moForget.password)) {
    moForget.passwordEmpty = true;
    return;
  }
  if (!trim(moForget.checkPwd)) {
    moForget.checkPwdErrorText = '确认密码不能为空';
    moForget.checkPwdEmpty = true;
    return;
  }
  if (moForget.password !== moForget.checkPwd) {
    moForget.checkPwdErrorText = '请输入相同密码';
    moForget.checkPwdEmpty = true;
    return;
  }
  toModify(callback);
});

export default moForget;
export {
  changePhone, changeCaptcha, changePassword, changeCheckPwd,
  getCaptcha, modifyPassword, reset,
};
